import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueObject } from '@digibricks/core'; // TODO: Move the 2 class Unixtimestamp to common module.

export var TimeFormat;

(function (TimeFormat) {
  TimeFormat["TwelveHour"] = "12h";
  TimeFormat["TwentyFourHour"] = "24h";
})(TimeFormat || (TimeFormat = {}));

export var UnixTimestamp = /*#__PURE__*/function (_ValueObject) {
  _inherits(UnixTimestamp, _ValueObject);

  var _super = _createSuper(UnixTimestamp);

  function UnixTimestamp() {
    _classCallCheck(this, UnixTimestamp);

    return _super.apply(this, arguments);
  }

  _createClass(UnixTimestamp, null, [{
    key: "convertToDate",
    value: function convertToDate(unixTimestamp) {
      var timeFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TimeFormat.TwelveHour;
      var timeConverted = new Date(parseInt(unixTimestamp));
      var year = timeConverted.getFullYear();
      var month = timeConverted.getMonth() + 1;
      var day = timeConverted.getDate();
      var hour = timeConverted.getHours();
      var minute = timeConverted.getMinutes();
      var dayTransform = day < 10 ? "0".concat(day) : "".concat(day);
      var monthTransform = month < 10 ? "0".concat(month) : "".concat(month);
      var minuteTransform = minute < 10 ? "0".concat(minute) : "".concat(minute);

      if (timeFormat === TimeFormat.TwelveHour) {
        var period = hour < 12 ? 'AM' : 'PM';
        var hour12 = hour % 12 || 12;

        var _hourTransform = hour12 < 10 ? "0".concat(hour12) : "".concat(hour12);

        return "".concat(dayTransform, "/").concat(monthTransform, "/").concat(year, " ").concat(_hourTransform, ":").concat(minuteTransform, " ").concat(period);
      }

      var hourTransform = hour < 10 ? "0".concat(hour) : "".concat(hour);
      return "".concat(dayTransform, "/").concat(monthTransform, "/").concat(year, " ").concat(hourTransform, ":").concat(minuteTransform);
    }
  }, {
    key: "now",
    value: function now() {
      return Date.now().toString();
    }
  }]);

  return UnixTimestamp;
}(ValueObject);